import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withCookies } from 'react-cookie';
import {
  TextField,
  Button,
  Grid,
  Select,
  MenuItem,
  FormControl,
} from '@material-ui/core';
import _ from 'lodash';
import {
  registerFarmerAction,
  registerOrgsAction,
  registerFarmconnectAction,
  getStakeHoldersOrgsAction,
  getRolesOrgsAction,
} from '../../Actions/appAction';
import {
  isName,
  isEmail,
  isPassword,
  isConfirmPassword,
} from '../../Functions/commonValidation';
import LanguageContext from '../common/languageContext';

class FarmerRegistration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      emailId: '',
      password: '',
      confirmPassword: '',
      firstNameError: false,
      lastNameError: false,
      emailError: false,
      passwordError: false,
      confirmPasswordError: false,
      companyName: '',
      roleName: '',
      licenseError: '',
      license: '',
      roleNameError: '',
      companyNameError: '',
    };
  }

  componentDidMount() {
    const {
      getStakeHolders,
      accountType,
      getRoles,
      accountTypeName,
    } = this.props;
    const data = {};
    data.stakeHolderID = accountType;
    getStakeHolders(data);
    const userRolesdata = {};
    userRolesdata.rolePrefix = accountTypeName;
    getRoles(userRolesdata);
  }

  _handleRegistrationField = (type, ev) => {
    if (type === 'firstName') {
      this.setState({
        firstName: ev.target.value,
        firstNameError: false,
      });
    }
    if (type === 'lastName') {
      this.setState({
        lastName: ev.target.value,
        lastNameError: false,
      });
    }
    if (type === 'license') {
      this.setState({
        license: ev.target.value,
        licenseError: false,
      });
    }
    if (type === 'emailId') {
      this.setState({
        emailId: ev.target.value,
        emailError: false,
      });
    }
    if (type === 'password') {
      this.setState({
        password: ev.target.value,
        passwordError: false,
      });
    }
    if (type === 'confirmPassword') {
      this.setState({
        confirmPassword: ev.target.value,
        confirmPasswordError: false,
      });
    }
  };

  _submitRegistartionForm = () => {
    const {
      /* registerFarmer, */
      verifiedMobile,
      /* registerOrgs, */
      registerFarmConnect,
      userRoles,
      stakeHolderOrg,
      verfiyMobileToken,
      accountType,
    } = this.props;
    const {
      firstName,
      lastName,
      emailId,
      password,
      confirmPassword,
      companyName,
      roleName,
      license,
    } = this.state;
    const findRole = userRoles.find(role => role.roleID === roleName);
    const findCompany = stakeHolderOrg.find(
      item => item.organisationID === companyName,
    );
    const firstNameErrorCheck = !isName(firstName);
    const lastNameErrorCheck = !isName(lastName);
    const emailErrorCheck = !isEmail(emailId);
    const passwordErrorCheck = !isPassword(password);
    const confirmPasswordErrorCheck = !isConfirmPassword(
      password,
      confirmPassword,
    );
    let licenseErrorCheck = false;
    let companyNameErrorCheck = false;
    let roleNameErrorCheck = false;
    if (!license) {
      licenseErrorCheck = true;
    }
    if (!companyName) {
      companyNameErrorCheck = true;
    }
    if (!roleName) {
      roleNameErrorCheck = true;
    }
    this.setState({
      firstNameError: firstNameErrorCheck,
      lastNameError: lastNameErrorCheck,
      emailError: emailErrorCheck,
      passwordError: passwordErrorCheck,
      confirmPasswordError: confirmPasswordErrorCheck,
      licenseError: licenseErrorCheck,
      roleNameError: roleNameErrorCheck,
      companyNameError: companyNameErrorCheck,
    });
    if (
      !firstNameErrorCheck
      && !lastNameErrorCheck
      && !emailErrorCheck
      && !passwordErrorCheck
      && !confirmPasswordErrorCheck
      && !licenseErrorCheck
      && !roleNameErrorCheck
      && !companyNameErrorCheck
    ) {
      // let data = this.state;
      // data.organizationTypeID = accountType;
      // data.organizationTypeName = accountTypeName;
      // debugger;

      const farmConnectData = {
        demographicesDetails: {
          name: `${firstName} ${lastName}`,
          mobile: verifiedMobile,
          emailID: emailId,
          password,
          address: '',
          token: verfiyMobileToken,
        },
        organisationDetails: {
          organisationID: findCompany.organisationID,
          organisationName: findCompany.organisationName,
          organisationTypeID: accountType,
        },
        userRoleDetails: {
          roleID: findRole.roleID,
          roleName: findRole.roleName,
          accessLevel: findRole.accessLevel,
          priority: findRole.priority,
          licenseKey: license,
        },
      };

      registerFarmConnect(farmConnectData);

      // if (accountTypeName !== 'Farmer') {
      //   const data = {};
      //   data.firstName = firstName;
      //   data.lastName = lastName;
      //   data.mobile = verifiedMobile;
      //   data.email = emailId;
      //   data.password = password;
      //   data.organizationTypeID = accountType;
      //   data.organizationTypeName = accountTypeName;
      //   registerOrgs(data);
      // } else {
      //   registerFarmer(this.state, verifiedMobile);
      // }
    }
  };

  _pushToFarmerSetup = () => {
    const { history, userData, cookies } = this.props;
    cookies.set('userData', userData, { path: '/' });
    cookies.set('loggedInTimeStamp', Date.now());
    history.push('/myaccount');
  };

  _pushToAccountSetup = () => {
    const { history, userData, cookies } = this.props;
    cookies.set('userData', userData, { path: '/' });
    cookies.set('loggedInTimeStamp', Date.now());
    const { data } = userData;
    const { userRoleData } = data;
    if (!_.isEmpty(userRoleData)) {
      history.push('/setup/step1');
    }
    // const { roles } = data;
    // if (roles[0].roleName === 'farmer') {
    //   history.push('/myaccount');
    // } else {
    //   history.push('/setup/step1');
    // }
  };

  _pushToWelcomeOnBoard = () => {
    const { history, userData, cookies } = this.props;
    cookies.set('userData', userData, { path: '/' });
    cookies.set('loggedInTimeStamp', Date.now());
    const { data } = userData;
    const { userRoleData } = data;
    if (!_.isEmpty(userRoleData)) {
      history.push('/setup/step3');
    }
  };

  handleKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      this._submitRegistartionForm();
      ev.preventDefault();
    }
  };

  handleCompanyChange = (e) => {
    this.setState({
      companyName: e.target.value,
      companyNameError: '',
    });
  };

  handleRoleChange = (e) => {
    this.setState({
      roleName: e.target.value,
      roleNameError: '',
    });
  };

  renderBeforeRegistration = () => {
    const { language } = this.context;
    const {
      firstName,
      lastName,
      emailId,
      password,
      confirmPassword,
      firstNameError,
      lastNameError,
      emailError,
      passwordError,
      confirmPasswordError,
      companyName,
      roleName,
      licenseError,
      license,
      roleNameError,
      companyNameError,
    } = this.state;
    const { registrationError, stakeHolderOrg, userRoles } = this.props;
    return (
      <div className="farmerDetails modal-info">
        <h4 className="top">
          {(language.hindi
            && language.hindi['Hurray You have succesfully Created'])
            || 'Hurray You have succesfully Created'}
        </h4>
        <h1>
          {(language.hindi && language.hindi['A New Account'])
            || 'A New Account'}
        </h1>
        <h6 className="bottom">Just enter your Primary Information</h6>
        <TextField
          error={!!firstNameError}
          helperText={firstNameError ? 'Please enter valid first name' : ''}
          id="firstName"
          label={(language.hindi && language.hindi.name) || 'First Name'}
          className="textField inputHead"
          margin="normal"
          onChange={ev => this._handleRegistrationField('firstName', ev)}
          value={firstName}
          onKeyPress={ev => this.handleKeyPress(ev)}
        />
        <TextField
          error={!!lastNameError}
          helperText={lastNameError ? 'Please enter valid last name' : ''}
          id="lastName"
          label={(language.hindi && language.hindi['Last Name']) || 'Last Name'}
          className="textField inputHead removeMargin"
          margin="normal"
          value={lastName}
          onChange={ev => this._handleRegistrationField('lastName', ev)}
          onKeyPress={ev => this.handleKeyPress(ev)}
        />
        <Grid container className="selectController">
          <Grid item lg={6} md={6} xs={6}>
            <FormControl className="formControl inputHead coloredForms inputFullWidth ">
              <Select
                disableUnderline
                name="dashboard-user"
                className="selectEmpty modalDropdown"
                onChange={e => this.handleCompanyChange(e)}
                value={companyName}
                displayEmpty
              >
                <MenuItem value="">Select Company</MenuItem>
                {stakeHolderOrg.map(item => (
                  <MenuItem value={item.organisationID}>
                    {item.organisationName}
                  </MenuItem>
                ))}
              </Select>
              {companyNameError ? (
                <p
                  className="MuiFormHelperText-root Mui-error"
                  style={{ marginTop: '12px' }}
                >
                  Please Select Company
                </p>
              ) : (
                ''
              )}
            </FormControl>
          </Grid>
          <Grid item lg={6} md={6} xs={6} className="selectController">
            <FormControl className="formControl  inputHead coloredForms inputFullWidth ">
              <Select
                disableUnderline
                name="dashboard-user"
                className="selectEmpty modalDropdown"
                onChange={e => this.handleRoleChange(e)}
                value={roleName}
                displayEmpty
              >
                <MenuItem value="">User type</MenuItem>
                {userRoles.map(item => (
                  <MenuItem value={item.roleID}>{item.roleName}</MenuItem>
                ))}
              </Select>
              {roleNameError ? (
                <p
                  className="MuiFormHelperText-root Mui-error"
                  style={{ marginTop: '12px' }}
                >
                  Please Select User Type
                </p>
              ) : (
                ''
              )}
            </FormControl>
          </Grid>
        </Grid>
        {/*        <div className="selectController">
        <FormControl className="formControl inputHead coloredForms inputFullWidth ">
          <Select
            disableUnderline
            name="dashboard-user"
            className="selectEmpty modalDropdown"
          >
            <MenuItem value="" disabled>
              Satellites
            </MenuItem>
            <MenuItem>hfdd</MenuItem>
          </Select>
        </FormControl>
        </div> */}
        <TextField
          error={!!licenseError}
          helperText={licenseError ? 'Please enter valid License Key' : ''}
          id="license"
          label={
            (language.hindi && language.hindi['License Key ']) || 'License Key'
          }
          className="textField inputHead"
          margin="normal"
          value={license}
          onChange={ev => this._handleRegistrationField('license', ev)}
          onKeyPress={ev => this.handleKeyPress(ev)}
        />
        <TextField
          error={!!emailError}
          helperText={emailError ? 'Please enter valid email Id' : ''}
          id="emailId"
          label={(language.hindi && language.hindi['Email ID']) || 'Email ID'}
          className="textField inputHead"
          margin="normal"
          value={emailId}
          onChange={ev => this._handleRegistrationField('emailId', ev)}
          onKeyPress={ev => this.handleKeyPress(ev)}
        />
        <TextField
          error={!!passwordError}
          helperText={
            passwordError ? 'Password should be greater than 8 digit' : ''
          }
          id="password"
          label={
            (language.hindi && language.hindi['enter password'])
            || 'Enter password'
          }
          type="password"
          className="textField inputHead"
          margin="normal"
          value={password}
          onChange={ev => this._handleRegistrationField('password', ev)}
          onKeyPress={ev => this.handleKeyPress(ev)}
        />
        <TextField
          error={!!confirmPasswordError}
          helperText={
            confirmPasswordError
              ? 'Your password and confirmation password do not match.'
              : ''
          }
          id="confirmPassword"
          label={
            (language.hindi && language.hindi['confirm password'])
            || 'Confirm password'
          }
          type="password"
          className="textField inputHead"
          margin="normal"
          value={confirmPassword}
          onChange={ev => this._handleRegistrationField('confirmPassword', ev)}
          onKeyPress={ev => this.handleKeyPress(ev)}
        />
        <p className="errorMsg">{registrationError}</p>
        <Grid container>
          <Grid lg={2} md={2} />
          <Grid lg={8} md={8}>
            <div className="darkgreenBtnHeader">
              <Button
                variant="contained"
                color="primary"
                className="button darkgreenBtn"
                onClick={this._submitRegistartionForm}
              >
                {(language.hindi && language.hindi.Finish) || 'Finish'}
              </Button>
            </div>
          </Grid>
          <Grid lg={2} md={2} />
        </Grid>
        {/*       <ul className="modalButtons">
          <li className="darkgreenBtnHeader marBot0">
            <Button
              variant="contained"
              color="primary"
              className="button darkgreenBtn"
              onClick={this._submitRegistartionForm}
            >
              {(language.hindi && language.hindi.Finish) || 'Finish'}
            </Button>
          </li>
        </ul> */}
      </div>
    );
  };

  renderAfterRegistration = () => {
    const { userData } = this.props;
    const { language } = this.context;
    return (
      <div className="registerModal modalHead">
        <div className="paper modalCarousel">
          <Grid item xs={12} className="successSec">
            <div className="button-area">
              <h3>
                {(language.hindi
                  && language.hindi['Hurray you have succesfully Submitted'])
                  || 'Hurray you have succesfully Submitted'}
              </h3>
              <h1>
                {(language.hindi && language.hindi['Welcome to Family'])
                  || 'Welcome to Family'}
                <span>
                  {userData.data
                    && userData.data.userData
                    && userData.data.userData.name}
                </span>
              </h1>
              <div className="completeProfile">
                <ul className="modalButtons">
                  <li className="darkgreenBtnHeader">
                    <Button
                      variant="contained"
                      color="primary"
                      className="button darkgreenBtn"
                      onClick={this._pushToAccountSetup}
                    >
                      {(language.hindi
                        && language.hindi['Complete Your Profile'])
                        || 'Complete Your Profile'}
                    </Button>
                  </li>
                </ul>
                <span
                  className="laterInfo"
                  onClick={this._pushToWelcomeOnBoard}
                  role="presentation"
                >
                  I’ll do it Later
                </span>
              </div>
            </div>
            <div className="downloadBtn">
              <Button>
                <i />
                Download farmguide App
              </Button>
            </div>
          </Grid>
        </div>
      </div>
    );
  };

  render() {
    // const { firstName, lastName, emailId, password, confirmPassword } = this.state;
    const { isRegistered } = this.props;
    return (
      <div>
        {!isRegistered
          ? this.renderBeforeRegistration()
          : this.renderAfterRegistration()}
      </div>
    );
  }
}

FarmerRegistration.contextType = LanguageContext;

export default withRouter(
  connect(
    ({ app }) => ({
      verifiedMobile: app.verifiedMobile,
      isRegistered: app.isRegistered,
      registrationError: app.registrationError,
      userData: app.userData,
      userRoles: app.userRoles,
      stakeHolderOrg: app.stakeHolderOrg,
      verfiyMobileToken: app.verfiyMobileToken,
    }),
    dispatch => ({
      registerFarmer: (farmerDetails, verifiedMobile) => {
        dispatch(registerFarmerAction(farmerDetails, verifiedMobile));
      },
      registerOrgs: (orgDetails) => {
        dispatch(registerOrgsAction(orgDetails));
      },
      registerFarmConnect: (orgDetails) => {
        dispatch(registerFarmconnectAction(orgDetails));
      },
      getStakeHolders: params => dispatch(getStakeHoldersOrgsAction(params)),
      getRoles: params => dispatch(getRolesOrgsAction(params)),
    }),
  )(withCookies(FarmerRegistration)),
);
